 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"2":"vendors~vsf-category~vsf-checkout~vsf-cms~vsf-compare~vsf-home~vsf-my-account~vsf-product~vsf-top-ba~dee0c57b","3":"vsf-category~vsf-compare~vsf-desktop-memu~vsf-home~vsf-my-account~vsf-not-found~vsf-related~vsf-rela~610fdd32","4":"vsf-compare~vsf-desktop-memu~vsf-home~vsf-my-account~vsf-not-found~vsf-product~vsf-search-panel~vsf-~b3ee85fa","5":"vendors~vsf-category~vsf-wp-categories-show~vsf-wp-posts-index~vsf-wp-posts-show","6":"vsf-color-selector-product~vsf-color-wariant-modal~vsf-product-custom-color","7":"vsf-checkout~vsf-microcart","8":"vsf-microcart~vsf-product","9":"SwipeActions","11":"for-download","12":"lang-pl-PL-json","14":"vendors~bodybuilder","15":"vendors~vsf-category","16":"vendors~vsf-checkout","17":"vendors~vsf-graphql","18":"vendors~vsf-search-panel","19":"vsf-account-icon","20":"vsf-async-bottom-sidebar","21":"vsf-async-sidebar","22":"vsf-blog-preview-product","23":"vsf-category","24":"vsf-checkout","25":"vsf-cms","26":"vsf-color-selector-product","27":"vsf-color-wariant-modal","28":"vsf-compare","29":"vsf-compare-icon","30":"vsf-contact-modal","31":"vsf-desktop-memu","32":"vsf-error","33":"vsf-footer","34":"vsf-forgotpass","35":"vsf-hamburger-icon","36":"vsf-header","37":"vsf-home","38":"vsf-inner-header","39":"vsf-languages-modal","40":"vsf-layout-default","41":"vsf-login","42":"vsf-mic-icon","43":"vsf-microcart","44":"vsf-microcart-icon","45":"vsf-my-account","46":"vsf-not-found","47":"vsf-order-confirmation","48":"vsf-placepozniej","49":"vsf-product","50":"vsf-product-custom-color","51":"vsf-product-gallery-carousel","52":"vsf-product-gallery-overlay","53":"vsf-product-gallery-zoom-carousel","54":"vsf-product-info-modal","55":"vsf-product-tabs","56":"vsf-register","57":"vsf-related","58":"vsf-related-bestseller","59":"vsf-related-small","60":"vsf-reset-password","61":"vsf-search-adapter-0","62":"vsf-search-adapter-1","63":"vsf-search-panel","64":"vsf-search-panel-desktop","65":"vsf-sidebar-menu","66":"vsf-sign-up","67":"vsf-top-bar","68":"vsf-typ","69":"vsf-wishlist","70":"vsf-wishlist-icon","71":"vsf-wp-categories-index","72":"vsf-wp-categories-show","73":"vsf-wp-posts-index","74":"vsf-wp-posts-show"}[chunkId]||chunkId) + "." + {"0":"0d9892dff7ea364c77e1","2":"8902e69046d7f64e1fd2","3":"b049e660953b05526c9b","4":"51412f14197a94ce0fb9","5":"cbe3297f519f785e286a","6":"9062c4902d37d615e8d2","7":"113b930b17e35c3127e9","8":"c4f380c28631d0f02d2c","9":"76130b1fa25616075b70","11":"35a746a93c06d0c21fa3","12":"b6ad50f87c9e19a62727","14":"501d467d2ad54bb19bc5","15":"0947cbcd1154a4c31788","16":"92c439cd6cf86022aec7","17":"ff28c1153e9cd653ea5e","18":"1146412ad8e3f6d54432","19":"379b700f0a5bf554229e","20":"c360130364bec3fef696","21":"825bf51f1ce7b26d93ec","22":"8cdefb5f190633c59b15","23":"0edb2a48e7235e48daf6","24":"7325426d4f3410487c09","25":"388065525847d4048541","26":"3713d0eff3081cc020fd","27":"1476e23bff51d40c10c2","28":"f21d55862ed80955bc46","29":"7724dec205af2926144f","30":"105293a42c0b651136fb","31":"b5a9f60b523eeca61d7f","32":"46f38e9de707a4b915ad","33":"d8ffeb589a215a16bc19","34":"51fa60a011da26d1b70f","35":"837449be44970f3b43ef","36":"3c649d3b800536a2f30f","37":"3582cce5041cf43161d5","38":"c20763df0da742f99591","39":"76cc0629a43219409f2d","40":"4fac984b507519bd0152","41":"f97c975b18cc72eaf3a7","42":"f2705b6b15c9b46d4b77","43":"d0d8d31c404cedd66a46","44":"cbbb6d6004ea1c924eb6","45":"3eee165e9a701e48d380","46":"541ae257380734c7c6c9","47":"6d0fed0e3a1139349b63","48":"3a8f7737d668c49b4b0b","49":"09893b8f6a03235b4857","50":"fead79f4fb580c56bc0a","51":"8e941e645161a0670fe0","52":"17aff5f4e9a6f1bc417f","53":"6db252fd8cca1905f936","54":"78aee7b28e97b700fc96","55":"28c99cea58d835b1d907","56":"9d0cf0bcab35c368e14d","57":"207662b93431c5cbe1ef","58":"291757c05bf1f751804c","59":"3f72e7eb8d18063ac04f","60":"7258e16d6d1a15f02096","61":"19a01b5096c670e746e4","62":"7f45700b4d3f6e047376","63":"9b3f479af3cd5816a6bd","64":"f8bd2fb3fb3552630889","65":"7db3adabf5c936719852","66":"d983be2b9902a61521e9","67":"cfec95aa0809ebe030d4","68":"50727f066c15c44083c7","69":"e6ace16bce9a68886a65","70":"8d06acd8bdf50912d3c5","71":"3d65d59d8f521adddcf6","72":"da5c90dfe52489c52554","73":"5fc8413cf5ed8515097a","74":"a43f7fe27bfd10e805a6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"40": [
 				1,
 				7,
 				8,
 				43,
 				3,
 				4,
 				69,
 				65
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
